export const AUTH0_AUDIENCE_URL = import.meta.env.VITE_AUTH0_AUDIENCE_URL;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
